
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Terms() {
  const sections = [
    {
      title: '服务条款的接受与修改',
      icon: 'ri-file-text-line',
      content: [
        {
          subtitle: '条款接受',
          items: [
            '在使用贝斯特体育服务之前，请您仔细阅读并完全理解本用户协议',
            '点击"同意"或"注册"按钮，即表示您已阅读并同意受本协议约束',
            '如果您不同意本协议的任何条款，请立即停止使用我们的服务',
            '未成年人使用本服务需要在法定监护人的同意和指导下进行'
          ]
        },
        {
          subtitle: '条款修改',
          items: [
            '我们有权随时修改本协议条款，修改后的协议将在网站上公布',
            '重大修改将通过站内信、邮件等方式提前30天通知用户',
            '如您不同意修改后的协议，可以选择停止使用服务',
            '继续使用服务即视为接受修改后的协议条款'
          ]
        }
      ]
    },
    {
      title: '服务内容与使用规则',
      icon: 'ri-tv-line',
      content: [
        {
          subtitle: '服务内容',
          items: [
            '体育赛事直播：提供足球、篮球、网球等各类体育赛事的实时直播',
            '精彩回放：赛事录播、精彩集锦、技术分析等视频内容',
            '体育资讯：最新的体育新闻、赛程安排、球队动态等信息',
            '社区互动：用户评论、讨论区、个人空间等社交功能',
            '个性化服务：根据用户偏好推荐相关内容和服务'
          ]
        },
        {
          subtitle: '使用规则',
          items: [
            '您只能为个人非商业目的使用本服务，不得用于任何商业用途',
            '禁止使用技术手段干扰网站正常运行或绕过付费限制',
            '不得复制、分发、传播网站上的受版权保护的内容',
            '遵守中华人民共和国相关法律法规，不得发布违法违规内容',
            '维护良好的社区环境，不得发布仇恨言论或进行人身攻击'
          ]
        }
      ]
    },
    {
      title: '账户管理',
      icon: 'ri-user-line',
      content: [
        {
          subtitle: '账户注册',
          items: [
            '您需要提供真实、准确、完整的个人信息进行账户注册',
            '您有义务及时更新注册信息，确保信息的准确性',
            '每个用户只能注册一个账户，不得恶意注册多个账户',
            '我们保留拒绝任何注册申请或取消已完成注册的权利'
          ]
        },
        {
          subtitle: '账户安全',
          items: [
            '您有责任维护账户密码的安全性，不得将账户借给他人使用',
            '如发现账户被盗用或存在安全风险，请立即联系客服',
            '因您未妥善保管账户信息而造成的损失，由您自行承担',
            '我们建议您定期修改密码并启用双重验证功能'
          ]
        },
        {
          subtitle: '账户暂停与终止',
          items: [
            '违反本协议或相关法律法规的账户可能被暂停或终止',
            '长期未使用的账户可能被注销，注销前会提前通知',
            '您可以随时申请注销账户，注销后相关数据将被删除',
            '账户终止后，您将失去访问平台内容和使用服务的权利'
          ]
        }
      ]
    },
    {
      title: '付费服务与退款政策',
      icon: 'ri-vip-crown-line',
      content: [
        {
          subtitle: 'VIP会员服务',
          items: [
            '我们提供包月、包季、包年等多种VIP会员套餐',
            'VIP用户可享受无广告观看、高清画质、独家内容等特权',
            '会员费用将在购买时一次性收取，支持多种支付方式',
            '会员服务期满后需要续费才能继续享受VIP特权'
          ]
        },
        {
          subtitle: '自动续费',
          items: [
            '开通自动续费的用户，系统将在到期前自动扣费续费',
            '用户可以随时在账户设置中关闭自动续费功能',
            '自动续费前会通过短信或邮件提醒用户',
            '续费失败时会保留3天的宽限期供用户处理'
          ]
        },
        {
          subtitle: '退款政策',
          items: [
            '数字内容产品特性决定，一般情况下不支持退款',
            '因系统故障导致无法正常使用服务时，可申请退款或延期',
            '重复支付、未成年人未经监护人同意的消费可申请退款',
            '退款申请需要提供相关证明材料，审核通过后5-7个工作日内退款'
          ]
        }
      ]
    },
    {
      title: '内容与版权',
      icon: 'ri-copyright-line',
      content: [
        {
          subtitle: '版权声明',
          items: [
            '网站上的所有内容均受版权法保护，包括但不限于视频、图片、文字等',
            '未经授权，禁止复制、修改、传播或用于商业目的',
            '我们尊重知识产权，如发现侵权行为将依法处理',
            '第三方内容的版权归其原始权利人所有'
          ]
        },
        {
          subtitle: '用户生成内容',
          items: [
            '用户发布的评论、帖子等内容，版权归用户所有',
            '用户授权我们使用、修改、复制、分发其发布的内容',
            '用户保证其发布的内容不侵犯第三方的合法权益',
            '我们有权对违规内容进行删除或修改'
          ]
        },
        {
          subtitle: '版权投诉',
          items: [
            '如认为我们的内容侵犯了您的版权，请及时联系我们',
            '投诉时请提供版权证明、侵权内容链接等必要信息',
            '我们会在收到投诉后24小时内响应，及时处理侵权内容',
            '恶意投诉或虚假投诉将承担相应的法律责任'
          ]
        }
      ]
    },
    {
      title: '用户行为规范',
      icon: 'ri-shield-check-line',
      content: [
        {
          subtitle: '禁止行为',
          items: [
            '发布违法违规、色情暴力、仇恨歧视等不当内容',
            '恶意刷屏、发布垃圾信息或进行商业推广',
            '冒充他人身份或发布虚假信息',
            '使用外挂、插件等技术手段干扰正常服务',
            '进行任何可能危害网络安全的行为'
          ]
        },
        {
          subtitle: '社区规范',
          items: [
            '保持友善和尊重，营造良好的讨论氛围',
            '就事论事，避免人身攻击和恶意诋毁',
            '尊重不同观点，理性表达个人意见',
            '积极举报违规行为，共同维护社区秩序',
            '保护个人隐私，不得泄露他人个人信息'
          ]
        },
        {
          subtitle: '违规处理',
          items: [
            '轻微违规：删除违规内容，给予警告',
            '严重违规：限制发言权限，暂停账户功能',
            '恶意违规：永久封禁账户，保留法律追究权利',
            '用户可以对处理结果提出申诉，我们会认真审核'
          ]
        }
      ]
    },
    {
      title: '免责声明',
      icon: 'ri-alert-line',
      content: [
        {
          subtitle: '服务中断',
          items: [
            '因系统维护、升级或故障可能导致服务暂时中断',
            '不可抗力因素（如自然灾害、政府行为）导致的服务中断',
            '第三方服务商问题导致的服务不可用',
            '我们会尽力减少服务中断时间，但不承担由此造成的损失'
          ]
        },
        {
          subtitle: '内容准确性',
          items: [
            '我们努力确保信息准确，但不保证所有信息的完全准确性',
            '赛事时间、比分等信息仅供参考，请以官方发布为准',
            '用户应理性看待体育比赛结果，不得进行非法博彩活动',
            '因信息错误造成的损失，我们不承担责任'
          ]
        },
        {
          subtitle: '第三方链接',
          items: [
            '网站可能包含指向第三方网站的链接，我们不对其内容负责',
            '访问第三方网站的风险由用户自行承担',
            '建议用户在访问第三方网站前阅读其服务条款和隐私政策',
            '第三方网站的服务质量和安全性由该网站负责'
          ]
        }
      ]
    },
    {
      title: '争议解决',
      icon: 'ri-scales-line',
      content: [
        {
          subtitle: '适用法律',
          items: [
            '本协议的签订、执行和解释均适用中华人民共和国法律',
            '如相关法律法规发生变化，以最新法律法规为准',
            '本协议的中文版本为正式版本，其他语言版本仅供参考',
            '协议条款如与法律法规冲突，以法律法规为准'
          ]
        },
        {
          subtitle: '争议处理',
          items: [
            '优先通过友好协商解决争议和纠纷',
            '协商不成的，可向我们的客服部门投诉',
            '如仍无法解决，可向有管辖权的人民法院提起诉讼',
            '诉讼管辖地为我们公司所在地的人民法院'
          ]
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-600 to-blue-600 py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              用户协议
            </h1>
            <p className="text-green-100 text-lg mb-6 max-w-3xl mx-auto">
              欢迎使用贝斯特体育服务！本协议规定了您使用我们服务时的权利和义务
            </p>
            <div className="flex items-center justify-center space-x-4 text-green-100">
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                <span className="text-sm">最后更新：2024年3月15日</span>
              </div>
              <div className="w-1 h-4 bg-green-300"></div>
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span className="text-sm">生效日期：2024年3月20日</span>
              </div>
            </div>
          </div>
        </section>

        {/* 重要提示 */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-gradient-to-r from-orange-50 to-red-50 border-l-4 border-orange-500 rounded-lg p-6 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-alert-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">重要提示</h2>
                    <div className="text-gray-700 space-y-3">
                      <p>
                        <strong className="text-red-600">请您务必审慎阅读、充分理解各条款内容</strong>，特别是免责或者限制责任的条款、法律适用和争议解决条款。限制、免责条款或者其他涉及您重大权益的条款可能以<strong className="text-red-600">加粗、加下划线</strong>等形式提示您重点注意。
                      </p>
                      <p>
                        除非您已阅读并接受本协议所有条款，否则您无权使用贝斯特体育提供的服务。您的使用行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
                      </p>
                      <p>
                        <strong>本协议是您与贝斯特体育之间关于您使用贝斯特体育服务所订立的协议。</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 定义条款 */}
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">定义与解释</h3>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div className="space-y-2">
                    <div><strong>贝斯特体育：</strong>指贝斯特体育科技有限公司</div>
                    <div><strong>用户：</strong>指注册、登录、使用本服务的个人或组织</div>
                    <div><strong>本服务：</strong>指贝斯特体育提供的各项互联网服务</div>
                  </div>
                  <div className="space-y-2">
                    <div><strong>平台：</strong>指贝斯特体育网站及移动应用程序</div>
                    <div><strong>内容：</strong>指平台上的文字、图片、视频等信息</div>
                    <div><strong>第三方：</strong>指除贝斯特体育和用户以外的任何个人或组织</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 详细条款 */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto space-y-8">
              {sections.map((section, index) => (
                <div key={index} className="bg-white rounded-lg shadow-sm">
                  <div className="p-6 border-b border-gray-100">
                    <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                      <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                        <i className={`${section.icon} text-green-600`}></i>
                      </div>
                      第{index + 1}条 {section.title}
                    </h2>
                  </div>
                  
                  <div className="p-6 space-y-6">
                    {section.content.map((item, itemIndex) => (
                      <div key={itemIndex}>
                        <h3 className="font-medium text-gray-900 mb-4 text-lg">
                          {index + 1}.{itemIndex + 1} {item.subtitle}
                        </h3>
                        <ul className="space-y-3">
                          {item.items.map((listItem, listIndex) => (
                            <li key={listIndex} className="flex items-start text-gray-700">
                              <span className="inline-block w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0 text-xs font-medium text-green-600">
                                {listIndex + 1}
                              </span>
                              <span className="leading-relaxed">{listItem}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 补充条款 */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-sm border">
                <div className="p-6 border-b border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-file-list-line text-blue-600"></i>
                    </div>
                    补充条款
                  </h2>
                </div>
                
                <div className="p-6 space-y-6">
                  <div>
                    <h3 className="font-medium text-gray-900 mb-3">协议的组成</h3>
                    <p className="text-gray-700 leading-relaxed">
                      本协议由本文本及《隐私政策》《社区规范》等相关规定共同组成。如本协议与前述规定存在不一致之处，以本协议为准。但若前述规定中有更严格的条款，则以前述规定为准。
                    </p>
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-3">协议的语言</h3>
                    <p className="text-gray-700 leading-relaxed">
                      本协议原始文本以中文撰写。无论用户使用何种语言版本的贝斯特体育服务或查阅本协议，均以中文版本为准。
                    </p>
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-3">协议的效力</h3>
                    <p className="text-gray-700 leading-relaxed">
                      本协议部分条款被认定为无效或不可执行的，不影响其他条款的效力。无效或不可执行的条款将被合法有效的条款所替代。
                    </p>
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-3">联系方式</h3>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="grid md:grid-cols-2 gap-4 text-sm">
                        <div>
                          <strong>公司名称：</strong>贝斯特体育科技有限公司<br/>
                          <strong>注册地址：</strong>北京市朝阳区体育大厦<br/>
                          <strong>邮政编码：</strong>100020
                        </div>
                        <div>
                          <strong>客服邮箱：</strong>service@bstyx.com<br/>
                          <strong>法务邮箱：</strong>legal@bstyx.com<br/>
                          <strong>客服电话：</strong>400-888-8888
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 协议接受确认 */}
        <section className="py-12 bg-gradient-to-r from-green-500 to-blue-600">
          <div className="container mx-auto px-4 text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl font-bold text-white mb-4">协议确认</h2>
              <p className="text-green-100 mb-6">
                如果您已经仔细阅读并完全理解本用户协议的全部内容，并愿意受其约束，请继续使用我们的服务。您的每一次访问和使用行为都表示您接受本协议。
              </p>
              <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <p className="text-white text-sm">
                  最后更新时间：2024年3月15日<br/>
                  生效时间：2024年3月20日
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
